import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import ReactMarkdown from 'react-markdown';
import '../pages/EconomicPage.css'

import nextThumbnail from '../assets/images/under_construction.png';
import stockThumbnail from '../assets/images/StockIndexPage__background.jpg';

const PROJECTS = [
  {
    key: 'stock',
    name: 'Stock Indices Forecasting',
    thumb: stockThumbnail,
    blurb: 'content/EconomicPage__blurbs/StockIndex__blurb.md'
  },
  {
    key: 'next',
    name: 'Loading...',
    thumb: nextThumbnail,
    blurb: '/content/EconomicPage__blurbs/Next__blurb.md'
  },
];

export default function EconomicPage({ onNavigate, onBack }) {
  const [blurbs, setBlurbs] = useState({});
  useEffect(() => {
    PROJECTS.forEach(project => {
      fetch(process.env.PUBLIC_URL + project.blurb)
        .then(res => res.text())
        .then(text => {
          setBlurbs(prev => ({ ...prev, [project.key]: text }));
        })
        .catch(console.error);
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>Economic Data Analysis Projects | Insight Data LLC</title>
      </Helmet>

      <div className='ea-home-container'>
        <div className="ea-tile-box">
          <div className="ea-tile-header">
            
            <div className='ea-back-button'>
              <button onClick={onBack} className="back-link">
                 Back to Projects
              </button>
            </div>

            <h1 style={{ fontSize: '2.5rem', marginBottom: '0.5rem', color: '#222' }}>
              Economic Data Analysis Projects
            </h1>

          </div>

          <div className="ea-project-grid">
            {PROJECTS.map(p => (
              <div key={p.key} className="ea-project-tile">
                <img
                  src={p.thumb}
                  alt={p.name}
                  className="ea-project-thumb"
                />

                <button
                  onClick={() => onNavigate(p.key)}
                  className="ea-project-button">
                  {p.name}
                </button>

                <div className="ea-project-blurb">
                  <ReactMarkdown>
                    {blurbs[p.key] || '_Loading..._'}
                  </ReactMarkdown>
                </div>

              </div>
            ))}
          </div>
        </div>

        <div className='ea-image-credit'>
          Background image by Gerd Altmann / Pixabay
        </div>

      </div>
    </>
  );
}